import RelatedLinks from './RelatedLinks'

export default RelatedLinks
